<template>
  <v-toolbar class="ma-3" color="transparent" flat>
    <v-spacer />
    <v-spacer />
    <div>
      <h2 class="Topbar-title">{{ displayName }}</h2>
    </div>
    <v-spacer />
    <v-switch
      class="mt-5"
      color="primaryAccent"
      v-model="acceptBooking"
      @change="handleToggle"
      :loading="loading"
      :disabled="loading"
      :label="$t('layout.topbar.acceptBooking')"
    />
    <v-spacer />
    <NotificationsIcon />
  </v-toolbar>
</template>

<script>
import { mapGetters } from 'vuex'
import NotificationsIcon from '@/components/ui/notifications/NotificationsIcon'
import gql from 'graphql-tag'

const UPDATE_SHOP = gql`
  mutation updateShop($shopUuid: GUID!, $shop: UpdateShopInput!) {
    updateShop(shopUuid: $shopUuid, shop: $shop) {
      shopUuid
      enabled
    }
  }
`

export default {
  components: {
    NotificationsIcon
  },
  data() {
    return {
      acceptBooking: this.$store.getters.currentShop.enabled,
      loading: false
    }
  },
  computed: {
    ...mapGetters(['currentShop']),
    displayName() {
      return this.currentShop.displayName
    }
  },
  methods: {
    async handleToggle() {
      this.loading = true

      try {
        const result = await this.$apollo.mutate({
          mutation: UPDATE_SHOP,
          variables: {
            shopUuid: this.currentShop.shopUuid,
            shop: {
              enabled: this.acceptBooking
            }
          }
        })
        if (result && result.data) {
          this.acceptBooking = result.data.updateShop.enabled
          this.$store.commit('SET_ACCEPT_BOOKING', this.acceptBooking)
        }

        this.sendGtmToggle()
        this.loading = false
      } catch {
        this.loading = false
        this.acceptBooking = !this.acceptBooking
      }
    },
    sendGtmToggle() {
      this.$gtm.trackEvent({
        event: 'ui_toggle',
        practitioner_id: this.$store.state.myUser.ecpId,
        shopUuid: this.currentShop.shopUuid,
        toggle: this.acceptBooking ? 'on' : 'off'
      })
    }
  }
}
</script>

<style>
.Topbar-title {
  padding: 5px 50px;
  text-transform: uppercase;
  border-bottom: 1px solid var(--v-secondary-base);
}
</style>
